export const FORECAST_PROGRESS_MESSAGES = [
  "Munching numbers... wait, NO! Crunching numbers. Spit those numbers out!",
  "Requesting that the intern AI fetch our digital coffee",
  "Consulting the council of extremely serious spreadsheets",
  "Polishing the crystal ball until it turns into a chart",
  "Asking the probability gremlins to please cite their sources",
  "Running a very scientific vibe check on the prior assumptions",
  "Convincing the confidence interval that confidence is not enough",
  "Sending tiny statisticians into the archives for historical context",
  "Untangling a suspicious knot of timelines and causal arrows",
  "Making sure Bayes did not sneak any extra drama into the math",
  "Teaching a neural net to raise one eyebrow at weak evidence",
  "Double-checking whether correlation is wearing causation's nametag again",
  "Gently removing conspiracy strings from the evidence board",
  "Bribing the Monte Carlo simulations with premium electrons",
  "Waiting for the charts to stop being so cryptic and start being helpful",
  "Handing the model a tiny detective hat and a stack of priors",
  "Measuring uncertainty with the good ruler instead of the cursed ruler",
  "Translating academic mumbling into actionable probability",
  "Asking several hypothetical experts to stop talking over each other",
  "Sweeping survivorship bias under a very visible rug labeled do not ignore",
  "Checking if the future has posted any spoilers",
  "Putting the rumor mill through a calibrated spin cycle",
  "Comparing scenarios on a scale from plausible to absolutely bold",
  "Rotating the evidence",
  "Trying not to let one dramatic datapoint become the main character",
  "Tightening every loose screw in the inference machine",
  "Sending the model to wash its hands after touching anecdotal evidence",
  "Checking the forecast against several internationally recognized shrugs",
  "Turning uncertainty into percentages without hurting its feelings",
  "Asking the evidence to please form a neat single-file line",
  "Deflating overconfident conclusions to the recommended PSI",
  "Sorting the inputs into signal, noise, and unhelpful yelling",
  "Convincing the model that maybe, just maybe, it should show its work",
  "Checking whether the null hypothesis is still lurking in the hallway",
  "Untying a bow made entirely of caveats",
  "Running the numbers through a sarcasm filter and then the real filter",
  "Listening for the faint hum of informed judgment",
  "Asking the confidence bands to leave a little room for humility",
  "Feeding the forecast a balanced diet of data, priors, and consequences",
  "Trying three reasonable worlds and one weirdly specific backup world",
  "Shining a flashlight into the darkest corners of the scenario tree",
  "Making the model explain itself without using the phrase it depends",
  "Checking whether the evidence is robust or just wearing robust-looking glasses",
  "Calibrating the certainty knob away from all the exciting wrong answers",
  "Running a background check on every suspiciously neat narrative",
  "Trying to predict the future without making the future feel watched",
  "Buffing the final probability until it gleams with cautious optimism",
  "Booting up the time machine",
  "Counting the moons of Jupiter... Why do they keep on moving? Ugh, now I need to start over again.",
]
